import { Component, inject, OnInit, signal } from '@angular/core';

import { DatePipe } from '@angular/common';
import { RainChartComponent } from './rain-chart/rain-chart.component';
import { MapComponent } from './map/map.component';
import { WaterbodiesComponent } from './waterbodies/waterbodies.component';
import { ProfileService } from './profile.service';
import { LoadingService } from './loading.service';
import { CalendarService } from './calendar.service';


@Component({
    selector: 'app-root',
    standalone: true,
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [RainChartComponent, MapComponent, WaterbodiesComponent, DatePipe],
})
export class AppComponent implements OnInit {
  title = 'rain-gauge-dashboard';
  protected readonly profile = inject(ProfileService);
  protected readonly loading = inject(LoadingService);
  private readonly calendarService = inject(CalendarService);

  protected calendarDate = signal<Date | null>(null);

  ngOnInit(): void {
    this.calendarService.getNow().subscribe({
      next: d => this.calendarDate.set(new Date(d)),
      error: () => {}
    });
  }
}
